<template lang="html">
  <div class="ind">
    <h1>This is admin panel</h1>
    <v-divider />
    <div style="width: 100%; display: flex; justify-content: center;">
      <div style="margin: 0px 10px; width: 100%;">
        <v-text-field label="Promo client" v-model="promo.client" type="text"></v-text-field>
        <v-select label="Promo organization" v-model="promo.id_organization" :items="organizations" item-text="name"
          item-value="id"></v-select>
        <v-text-field label="Promo code" v-model.trim="promo.value" type="text"></v-text-field>
        <v-select label="Promo position" v-model="promo.position" :items="[
          {
            value: 'doctor',
            label: 'Doctor',
          },
          {
            value: 'patient',
            label: 'Patient',
          },
          {
            value: 'director',
            label: 'Director',
          },

        ]" item-text="label" item-value="value"></v-select>
        <v-select label="Period" v-model="promo.type" :items="[
          {
            value: '1',
            label: '1 Day',
          },
          {
            value: '3',
            label: '3 Days',
          },
          {
            value: '5',
            label: '5 Days',
          },
          {
            value: '7',
            label: 'Week',
          },
          {
            value: '30',
            label: 'Month',
          },
          {
            value: '60',
            label: 'Two month subscription',
          },
          {
            value: '91',
            label: 'Quarter',
          },
          {
            value: '184',
            label: 'Half year',
          },
          {
            value: '365',
            label: 'Year',
          },
          {
            value: '1095',
            label: '3 Years',
          },
        ]" item-text="label" item-value="value"></v-select>
      </div>
      <div style="margin: 0px 10px; width: 100%;">
        <v-text-field v-if="promo.position == 'doctor'" label="Discount" v-model="promo.discount" type="number" min="0"
          max="99"></v-text-field>
        <v-text-field v-if="promo.position == 'doctor'" label="Month balance" v-model="promo.month"
          type="number"></v-text-field>
        <v-text-field label="Limit" v-model="promo.limit" type="number"></v-text-field>
        <v-switch v-if="promo.position == 'doctor'" v-model="promo.doctorSubscription"
          label="Can doctor use months for subscription" />
        <v-switch v-if="promo.position == 'patient'" v-model="promo.subscribe_via_doctor"
          label="Subscription via doctor month" />

        <v-btn @click="newPromoCode" color="success">
          create
        </v-btn>
      </div>
    </div>

    <v-dialog v-model="dialogUpdate" v-if="selected != null" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Updating
        </v-card-title>

        <div style="width: 100%; display: flex; justify-content: center;">
          <div style="margin: 0px 10px; width: 100%;padding: 0px 15px;">
            <v-text-field label="Promo client" v-model="selected.client" type="text"></v-text-field>
            <v-select label="Promo organization" v-model="selected.id_organization" :items="organizations"
              item-text="name" item-value="id"></v-select>
            <v-text-field label="Promo code" v-model.trim="selected.value" type="text"></v-text-field>
            <v-select label="Promo position" v-model="selected.position" :items="[
              {
                value: 'doctor',
                label: 'Doctor',
              },
              {
                value: 'patient',
                label: 'Patient',
              },
              {
                value: 'director',
                label: 'Director',
              },

            ]" item-text="label" item-value="value"></v-select>
            <v-select label="Period" v-model="selected.type" :items="[
              {
                value: '1',
                label: '1 Day',
              },
              {
                value: '3',
                label: '3 Days',
              },
              {
                value: '5',
                label: '5 Days',
              },
              {
                value: '7',
                label: 'Week',
              },
              {
                value: '30',
                label: 'Month',
              },
              {
                value: '91',
                label: 'Quarter',
              },
              {
                value: '184',
                label: 'Half year',
              },
              {
                value: '365',
                label: 'Year',
              },
              {
                value: '1095',
                label: '3 Years',
              }
            ]" item-text="label" item-value="value"></v-select>
          </div>
          <div style="margin: 0px 10px; width: 100%;">
            <v-text-field v-if="selected.position == 'doctor'" label="Discount" v-model="selected.discount" type="number"
              min="0" max="99"></v-text-field>
            <v-text-field v-if="selected.position == 'doctor'" label="Month balance" v-model="selected.month"
              type="number"></v-text-field>
            <v-text-field label="Limit" v-model="selected.limit" type="number"></v-text-field>
            <v-switch v-if="selected.position == 'doctor'" v-model="selected.doctorSubscription"
              label="Can doctor use months for subscription" />
            <v-switch v-if="selected.position == 'patient'" v-model="selected.subscribe_via_doctor"
              label="Subscription via doctor month" />
          </div>
        </div>
        <v-divider></v-divider>


        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" flat @click="update">
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout style="margin-top:20px;">
      <v-text-field solo label="Search by code or client" v-model="search" @input="sortPromosBySearch"></v-text-field>
    </v-layout>
    <v-layout row align-start class="py-2">
      <!-- { text: 'CITY', value: 'city' }, -->
      <v-data-table v-if="promo.promos" :headers="[
        { text: 'CLIENT', value: 'client' },
        { text: 'CODE', value: 'value' },
        { text: 'ORGANIZATION', value: 'id_organization' },
        { text: 'POSITION', value: 'position' },
        { text: 'PERIOD', value: 'period' },
        { text: 'DISCOUNT', value: 'discount' },
        { text: 'MONTH BALANCE', value: 'month' },
        { text: 'MONTH FOR DOCTOR SUBSCRIPTION', value: 'subs' },
        { text: 'USED', value: 'used' },
        { text: 'LIMIT', value: 'limit' },
        { text: 'UPDATE', value: 'update', sortable: false },
        { text: 'DELETE', value: 'actions', sortable: false },
      ]" :items="promo.promos" class="pb-4">
        <template v-slot:item.img="{ item }">
          <img class="promo_img" :src="item.img.url" v-if="item.img != null" />
        </template>
        <template v-slot:item.subs="{ item }">
          <span v-if="item.doctorSubscription == 1">TRUE</span>
          <span v-else>FALSE</span>
        </template>
        <template v-slot:item.period="{ item }">
          <span v-if="item.type == 1">1 Day</span>
          <span v-else-if="item.type == 3">3 Days</span>
          <span v-else-if="item.type == 5">5 Days</span>
          <span v-else-if="item.type == 7">Week</span>
          <span v-else-if="item.type == 30">Month</span>
          <span v-else-if="item.type == 91">Quarter</span>
          <span v-else-if="item.type == 184">Half year</span>
          <span v-else-if="item.type == 365">Year</span>
          <span v-else-if="item.type == 1095">3 Years</span>
          <span v-else> {{ item.type != null ? 'type: ' + item.type : '' }} </span>
        </template>

        <template v-slot:item.up="{ item }">
          <v-btn v-if="item.position == '' || item.position == null" @click="uploadImg(item)"
            color="success">upload</v-btn>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn @click="deletePromoCode(item)" color="error">delete</v-btn>
        </template>


        <template v-slot:item.update="{ item }">
          <v-btn text @click="edit(item)" color="info">EDIT</v-btn>
        </template>


        <template v-slot:item.id_organization="{ item }">
          {{ getOrganizationName(item.id_organization) }}
        </template>
        <template v-slot:item.limit="{ item }">
          <template v-if="item.limit == 0">
            unlimited
          </template>
          <template v-else>
            {{ item.limit - item.used }}
          </template>
        </template>
      </v-data-table>
      <v-dialog v-model="dialog.promoSetting" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Updating promo settings
          </v-card-title>
          <v-card-title>
            Playlist Settings
          </v-card-title>

          <v-card-text>
            <div
              style="padding: 10px; width: 100%; display: flex; flex-direction: row; justify-content: space-between;">
              <div>
                <v-switch label="Children" id="checkboxchild" @change="locationsSort('child')"
                  v-model="section.child" />
              </div>
              <div>
                <v-switch label="Adults" id="checkboxadult" @change="locationsSort('adult')" v-model="section.adult" />
              </div>
              <div>
                <v-switch label="Family" id="checkboxfamily" @change="locationsSort('family')"
                  v-model="section.family" />
              </div>
            </div>
            <div>
              <v-btn @click="saveSections" color="success" style="margin-bottom: 20px;">
                Save Sections
              </v-btn>
            </div>
            <div v-if="section.child == true || section.adult == true || section.family == true" class="display-1 mb-2">Locations
            </div>
            <v-divider v-if="section.child == true || section.adult == true || section.family == true" />
            <v-layout v-if="section.child == true || section.adult == true || section.family == true" row align-start
              class="pt-4">
              <v-select label="Locations" @input="onLocationsChange"
                :value="resultedSettings.locations.map(n => n.id_location)" chips :items="locations" item-text="name"
                item-value="id_setting" solo multiple></v-select>
            </v-layout>
            <div class="display-1 mb-2">Gifts</div>
            <v-divider />
            <v-layout row align-start class="pt-4">
              <v-select label="In promo gifts" v-model="resultedSettings.categories" chips :items="categories"
                item-text="name" item-value="id_category" solo multiple></v-select>

            </v-layout>
            <v-divider></v-divider>
            <v-card-title>
              Shootlist Settings
            </v-card-title>
            <div class="display-1 mb-2">Shootlist categories</div>
            <v-divider />
            <v-layout row align-start class="pt-4">
              <v-select label="In promo shootlist categories" v-model="resultedSettingsQuestions" chips
                :items="shootlistCategories" item-text="name" item-value="id" solo multiple></v-select>

            </v-layout>
            <div>
              <v-btn @click="sendData" color="success">
                Send settings
              </v-btn>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>

          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-divider />
    <v-layout row align-start class="py-4">
      <div style="display: flex; flex-direction: column;">
        <div style="display: flex; flex-direction: row;">
          <v-text-field label="Treatment basik" v-model="prices.t_basik" type="number"></v-text-field>
          <v-text-field label="Treatment extended" v-model="prices.t_extended" type="number"></v-text-field>
        </div>
      </div>


      <v-text-field label="Price of month subscription" v-model="prices.monthly_subscription"
        type="number"></v-text-field>
      <v-btn @click="updatePrices" color="success">
        save
      </v-btn>
    </v-layout>
    <v-layout row align-start class="py-3" v-for="variable in variables" :key="variable.id_variable"  v-if="variable.name != 'games_restricted' && variable.name != 'subgoals_restricted' && variable.name != 'connections_restricted'">
      <v-layout row align-start class="pb-3">
        <v-text-field :label="`${variable.name}`" v-model="variable.value" type="text" class="pr-3"
          :disabled="variable.name == 'presentation_visit' || variable.name == 'sitelink_visit' ? true : false"></v-text-field>
        <v-btn @click="updateVariable(variable)" color="success"
          v-if="variable.name != 'presentation_visit' && variable.name != 'sitelink_visit'">
          save
        </v-btn>
      </v-layout>
    </v-layout>

    <input v-show="false" ref="file" type="file" accept="image/*" @change="updateImage">
    <v-snackbar v-model="alert.update" right top :timeout="2000">
      Updated.
      <v-btn color="pink" flat @click="alert.update = false">
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      discounts: ['10', '20', '30', '40', '50'],
      dialogUpdate: false,
      dialog: {
        promoSetting: false,
        discountSettings: false,
      },
      alert: {
        update: false,
        delete: false,
      },
      search: null,
      promo: {
        promos: [],
        promosDefault: [],
        client: '',
        value: '',
        type: '',
        games: 40,
        position: '',
        schoolId: '',
        limit: 0,
        renew: false,
        days: 0,
        doctorSubscription: true,
        subscribe_via_doctor: true,
      },
      isOrganization: true,
      prices: {},
      variables: [],
      schools: [],
      organizations: [],
      shootlistvariables: [],
      selected: null,
      discount: null,
      type: null,
      days: 0,
      locationsData: null,
      locations: null,
      categories: null,
      shootlistCategories: null,
      section: {
        child: false,
        adult: false,
        family: false
      },
      resultedSettings: {
        sections: [],
        locations: [],
        categories: []
      },
      resultedSettingsQuestions: null,
    };
  },
  methods: {
    sortPromosBySearch(e) {
      this.promo.promos = this.promo.promosDefault.filter(x => x.value.toLowerCase().includes(e.toLowerCase()) || x.client.toLowerCase().includes(e.toLowerCase()));
      this.promo.promos = this.promo.promos.sort((a, b) => (a.client != "" ? a.client : Infinity) > (b.client != "" ? b.client : Infinity));
    },
    locationsSort(e) {
      switch (e) {
        case 'child':
          if (this.section.child == true) {
            if (this.section.adult == false && this.section.family == false) {
              this.locations = this.locationsData.filter(x => x.type == 'child');
            }
            else if (this.section.adult == false && this.section.family == true) {
              this.locations = this.locationsData.filter(x => x.type == 'child' || x.type == 'family');
            }
            else if (this.section.adult == true && this.section.family == false) {
              this.locations = this.locationsData.filter(x => x.type == 'child' || x.type == 'adult');
            }
            else if (this.section.adult == true && this.section.family == true) {
              this.locations = this.locationsData;
            }
          }
          else {
            if (this.section.adult == true && this.section.family == true) {
              this.locations = this.locationsData.filter(x => x.type == 'family' || x.type == 'adult');
            }
            else if (this.section.adult == true && this.section.family == false) {
              this.locations = this.locationsData.filter(x => x.type == 'adult');
            }
            else if (this.section.adult == false && this.section.family == true) {
              this.locations = this.locationsData.filter(x => x.type == 'family');
            }
            else if (this.section.adult == false && this.section.family == false) {
              this.locations = null;
            }
          }
          break;


        case 'adult':
          if (this.section.adult == true) {
            if (this.section.child == false && this.section.family == false) {
              this.locations = this.locationsData.filter(x => x.type == 'adult');
            }
            else if (this.section.child == false && this.section.family == true) {
              this.locations = this.locationsData.filter(x => x.type == 'adult' || x.type == 'family');
            }
            else if (this.section.child == true && this.section.family == false) {
              this.locations = this.locationsData.filter(x => x.type == 'adult' || x.type == 'child');
            }
            else if (this.section.child == true && this.section.family == true) {
              this.locations = this.locationsData;
            }
          }
          else {
            if (this.section.child == true && this.section.family == true) {
              this.locations = this.locationsData.filter(x => x.type == 'family' || x.type == 'child');
            }
            else if (this.section.child == true && this.section.family == false) {
              this.locations = this.locationsData.filter(x => x.type == 'child');
            }
            else if (this.section.child == false && this.section.family == true) {
              this.locations = this.locationsData.filter(x => x.type == 'family');
            }
            else if (this.section.child == false && this.section.family == false) {
              this.locations = null;
            }
          }
          break;


        case 'family':
          if (this.section.family == true) {
            if (this.section.child == false && this.section.adult == false) {
              this.locations = this.locationsData.filter(x => x.type == 'family');
            }
            else if (this.section.child == false && this.section.adult == true) {
              this.locations = this.locationsData.filter(x => x.type == 'adult' || x.type == 'family');
            }
            else if (this.section.child == true && this.section.adult == false) {
              this.locations = this.locationsData.filter(x => x.type == 'family' || x.type == 'child');
            }
            else if (this.section.child == true && this.section.adult == true) {
              this.locations = this.locationsData;
            }
          }
          else {
            if (this.section.child == true && this.section.adult == true) {
              this.locations = this.locationsData.filter(x => x.type == 'adult' || x.type == 'child');
            }
            else if (this.section.child == true && this.section.adult == false) {
              this.locations = this.locationsData.filter(x => x.type == 'child');
            }
            else if (this.section.child == false && this.section.adult == true) {
              this.locations = this.locationsData.filter(x => x.type == 'adult');
            }
            else if (this.section.child == false && this.section.adult == false) {
              this.locations = null;
            }
          }
          break;
        default:
          break;
      }

      let array = [];
      this.resultedSettings.locations = this.resultedSettings.locations.filter(x => this.locations.includes(x.id_location));
    },
    getCategory() {

      axios.get('/shootlist/categoryAdm').then(res => {
        this.shootlistCategories = res.data.categories;
      });

    },
    syncLocations() {
      axios.get('/playlist/settings').then(res => {
        this.locationsData = res.data;
        this.locations = this.locationsData;
      });
    },
    syncCategories() {
      axios.get('/playlist/categories').then(res => {
        this.categories = res.data;
      });
    },
    onLocationsChange(value) {
      console.log(value)
      this.resultedSettings.locations = value.map(n => {
        const loc = this.resultedSettings.locations.find(z => z.id_location == n);
        return {
          id_location: n,
        }
      });

    },
    sendData() {
      this.selected.settings_games = this.resultedSettings;
      this.selected.settings_questions = this.resultedSettingsQuestions;
      axios.post('/admin/promo/editPromoSettings', {
        data: this.selected
      }).then(res => {
        this.alert.update = true;
      });
    },
    saveSections() {
      let arr = [];
      if (this.section.child == true) {
        arr.push('child');
      }
      if (this.section.adult == true) {
        arr.push('adult');
      }
      if (this.section.family == true) {
        arr.push('family');
      }
      console.log(arr)
      this.resultedSettings.sections = arr;
      this.selected.settings_games = arr;
    },
    uploadImg(item) {

      this.selected = item;
      this.$refs.file.click()
    },
    updateImage() {
      var data = new FormData();
      data.append('file', this.$refs.file.files[0]);
      axios.post('/admin/promo/storeImg/' + this.selected.id_promo, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.selected.img = res.data;
      });
    },
    getOrganizationName(id) {
      var organization = this.organizations.find(organization => Number(organization.id) == Number(id));
      return organization ? organization.name : '';
    },
    getOrganization() {
      axios.get('/organization').then(res => {
        this.organizations = res.data;
        // console.log(this.schools);
      });
    },
    newPromoCode() {
      if (
        this.promo.client !== null &&
        this.promo.client !== '' &&
        this.promo.position !== null &&
        this.promo.position !== '' &&
        this.promo.id_organization !== null &&
        this.promo.id_organization !== '' &&
        this.promo.id_organization !== undefined &&
        this.promo.value !== null &&
        this.promo.value !== '' &&
        this.promo.limit !== null &&
        this.promo.limit !== '' &&
        this.isOrganization !== null
      ) {
        axios.post('/admin/promo', {
          client: this.promo.client,
          position: this.promo.position,
          id_organization: this.promo.id_organization,
          value: this.promo.value,
          type: this.promo.type,
          games: this.promo.games,
          renew: this.promo.renew,
          discount: this.promo.discount != null && this.promo.discount != '' ? this.promo.discount : 0,
          limit: this.promo.limit,
          month: this.promo.month,
          isOrganization: this.isOrganization,
          days: this.promo.days,
          doctorSubscription: this.promo.doctorSubscription,
          subscribe_via_doctor: this.promo.subscribe_via_doctor
        }).then(res => {
          this.promo.client = null;
          this.promo.position = null;
          this.promo.schoolId = null;
          this.promo.value = null;
          this.promo.type = null;
          this.promo.games = null;
          this.promo.month = null;
          this.promo.doctorSubscription = null;
          this.promo.limit = 0;
          this.getPromoCodes();
          alert('Promo code was added');
        }).catch(err => {
          alert('Promo code with this code already exists');
        });
      }
      else {
        alert('Please fill in all required fields');
      }
    },
    getPromoCodes() {
      axios.get('/admin/promo').then(res => {
        this.promo.promosDefault = res.data.sort((a, b) => a.client.toLowerCase() > b.client.toLowerCase() ? 1 : -1);
        this.promo.promos = res.data.sort((a, b) => a.client != '' && b.client != '' ? (a.client.toLowerCase() > b.client.toLowerCase() ? 1 : -1) : -1);
      });
    },
    updatePromoCode(item) {
      axios.put('/admin/promo/' + item.id_promo, {
        value: item.value,
      });
    },
    deletePromoCode(item) {
      axios.delete('/admin/promo/' + item.id_promo).then(res => {
        this.getPromoCodes();
      });
    },
    edit(item) {
      this.selected = JSON.parse(JSON.stringify(item));
      this.dialogUpdate = true;
      // if(this.selected.settings_games != null)
      // {
      //   this.resultedSettings.locations = this.selected.settings_games.locations;
      //   this.resultedSettings.categories = this.selected.settings_games.categories;
      //   if(this.selected.settings_games.sections.includes('child'))
      //   {
      //     this.section.child=true;
      //   }
      //   else
      //   {
      //     this.section.child=false;
      //   }
      //   if(this.selected.settings_games.sections.includes('adult'))
      //   {
      //     this.section.adult=true;
      //   }
      //   else
      //   {
      //     this.section.adult=false;
      //   }
      //   if(this.selected.settings_games.sections.includes('family'))
      //   {
      //     this.section.family=true;
      //   }
      //   else
      //   {
      //     this.section.family=false;
      //   }
      // }
      // else
      // {
      //   this.section.family = false;
      //   this.section.adult = false;
      //   this.section.child = false;
      // }
      // if(this.selected.settings_questions != null)
      // {
      //   this.resultedSettingsQuestions = this.selected.settings_questions;
      // }
      // else
      // {
      //   this.resultedSettingsQuestions = null;
      // }
      // this.selected.settings_games.sections.forEach(element=>{
      //   console.log(element)
      // // })
      // this.saveSections();
      // console.log(this.selected)
    },
    editDis(item) {
      this.selected = item;
      this.discount = item.discount;
      this.dialog.discountSettings = true;
    },
    updatePrices() {
      axios.put('/admin/prices', {
        prices: this.prices
      });
    },
    update() {
      if (
        this.selected.client !== null &&
        this.selected.client !== '' &&
        this.selected.position !== null &&
        this.selected.position !== '' &&
        this.selected.id_organization !== null &&
        this.selected.id_organization !== '' &&
        this.selected.id_organization !== undefined &&
        this.selected.value !== null &&
        this.selected.value !== '' &&
        this.selected.limit !== null &&
        this.selected.limit !== '' &&
        this.isOrganization !== null
      ) {
        axios.post('/admin/promo/update', {
          id_promo: this.selected.id_promo,
          client: this.selected.client,
          position: this.selected.position,
          id_organization: this.selected.id_organization,
          value: this.selected.value,
          type: this.selected.type,
          games: this.selected.games,
          renew: this.selected.renew,
          discount: this.selected.discount != null && this.selected.discount != '' ? this.selected.discount : 0,
          limit: this.selected.limit,
          month: this.selected.month,
          isOrganization: this.isOrganization,
          days: this.selected.days,
          doctorSubscription: this.selected.doctorSubscription,
          subscribe_via_doctor: this.selected.subscribe_via_doctor
        }).then(res => {
          this.selected = null;
          this.getPromoCodes();
          alert('Promo code was updated');
        }).catch(err => {
          alert('Promo code with this code already exists');
        });
      }
      else {
        alert('Please fill in all required fields');
      }
    },
    getPrices() {
      axios.get('/admin/prices').then(res => {
        this.prices = res.data.value;
      });
    },
    getVariables() {
      axios.get('/admin/variable').then(res => {
        this.variables = res.data;
      });
    },
    getShootVariables() {
      axios.get('/admin/variable/getShootVariables').then(res => {
        this.shootlistvariables = res.data;
      });
    },
    updateVariable(variable) {
        axios.put('/admin/variable/' + variable.id_variable, {
          value: variable.value,
        });
    },
  },
  created() {

    this.getOrganization();
    this.getPromoCodes();
    this.getPrices();
    this.getVariables();
    this.syncLocations();
    this.syncCategories();
    this.getCategory();
  }
}
</script>

<style lang="scss" scoped>
.ind {
  padding-left: 400px !important;
  padding-right: 50px !important
}

.promo_img {
  max-width: 50px;
  // max-height: 100%;
}
</style>
